// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BulkProductsController from "./bulk_products_controller"
application.register("bulk-products", BulkProductsController)

import CharCountController from "./char_count_controller"
application.register("char-count", CharCountController)

import DeliveryCarrierController from "./delivery_carrier_controller"
application.register("delivery-carrier", DeliveryCarrierController)

import IrisLimitController from "./iris_limit_controller"
application.register("iris-limit", IrisLimitController)

import UnitContentController from "./unit_content_controller"
application.register("unit-content", UnitContentController)

import SeasonalToggleController from "./seasonal_toggle_controller"
application.register("seasonal-toggle", SeasonalToggleController)

import VolumeTiersController from "./volume_tiers_controller"
application.register("volume-tiers", VolumeTiersController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ChatSheetController from "./chat_sheet_controller"
application.register("chat-sheet", ChatSheetController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import CsvUploadController from "./csv_upload_controller"
application.register("csv-upload", CsvUploadController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EshopPickerController from "./eshop_picker_controller"
application.register("eshop-picker", EshopPickerController)

import ExpandableTextController from "./expandable_text_controller"
application.register("expandable-text", ExpandableTextController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import FilterModalController from "./filter_modal_controller"
application.register("filter-modal", FilterModalController)

import GeolocationController from "./geolocation_controller"
application.register("geolocation", GeolocationController)

import HelpSheetController from "./help_sheet_controller"
application.register("help-sheet", HelpSheetController)

import HorizontalScrollController from "./horizontal_scroll_controller"
application.register("horizontal-scroll", HorizontalScrollController)

import FormGuardController from "./form_guard_controller"
application.register("form-guard", FormGuardController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import ImageSelectorController from "./image_selector_controller"
application.register("image-selector", ImageSelectorController)

import LandingCtaController from "./landing_cta_controller"
application.register("landing-cta", LandingCtaController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import MapboxAutocompleteController from "./mapbox_autocomplete_controller"
application.register("mapbox-autocomplete", MapboxAutocompleteController)

import OnboardingWizardController from "./onboarding_wizard_controller"
application.register("onboarding-wizard", OnboardingWizardController)

import OrderChatController from "./order_chat_controller"
application.register("order-chat", OrderChatController)

import OrderFormController from "./order_form_controller"
application.register("order-form", OrderFormController)

import PriceRangeController from "./price_range_controller"
application.register("price-range", PriceRangeController)

import ProductFormController from "./product_form_controller"
application.register("product-form", ProductFormController)

import ProductGalleryController from "./product_gallery_controller"
application.register("product-gallery", ProductGalleryController)

import PushNotificationsController from "./push_notifications_controller"
application.register("push-notifications", PushNotificationsController)

import PushPromptController from "./push_prompt_controller"
application.register("push-prompt", PushPromptController)

import SearchDrawerController from "./search_drawer_controller"
application.register("search-drawer", SearchDrawerController)

import SellerDecisionController from "./seller_decision_controller"
application.register("seller-decision", SellerDecisionController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import StoreNamePreviewController from "./store_name_preview_controller"
application.register("store-name-preview", StoreNamePreviewController)

import StripeRedirectController from "./stripe_redirect_controller"
application.register("stripe-redirect", StripeRedirectController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import VideoFacadeController from "./video_facade_controller"
application.register("video-facade", VideoFacadeController)

import VideoUrlListController from "./video_url_list_controller"
application.register("video-url-list", VideoUrlListController)

import RfqOfferController from "./rfq_offer_controller"
application.register("rfq-offer", RfqOfferController)

import PickerController from "./picker_controller"
application.register("picker", PickerController)

import PickerLinkController from "./picker_link_controller"
application.register("picker-link", PickerLinkController)
